import { render, staticRenderFns } from "./EventPlayers.vue?vue&type=template&id=240d5a6c&scoped=true"
import script from "./EventPlayers.vue?vue&type=script&lang=js"
export * from "./EventPlayers.vue?vue&type=script&lang=js"
import style0 from "./EventPlayers.vue?vue&type=style&index=0&id=240d5a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d5a6c",
  null
  
)

export default component.exports